import { FormattedMessage, useIntl } from 'react-intl';

import { Box } from '../../../common/box';
import { LoginForm } from '../login-form';
import { ILoginProps } from './login.models';
import { Page } from '../page/page';

export const Login = ({ onLogin }: ILoginProps): JSX.Element => {
  const intl = useIntl();

  return (
    <Page
      title={intl.formatMessage({ id: 'loginPage.title' })}
      description={intl.formatMessage({ id: 'loginPage.description' })}
    >
      <Box
        title={<FormattedMessage id="login.title" />}
        isBackButton
        isBackButtonState={false}
      >
        <LoginForm onSubmit={onLogin} />
      </Box>
    </Page>
  );
};
